import { Tooltip } from '@mui/material';
import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { enGB } from 'date-fns/locale';

interface Props {
  date: Date | string | null | undefined;
  titlePrefix?: string;
  tooltip?: boolean;
}

const Span = ({ children, ...other }: { children: React.ReactNode }) => (
  <span {...other}>{children}</span>
);

export const TimeAgo: React.ComponentType<Props> = ({
  date: rawDate,
  titlePrefix,
  tooltip = true,
}: Props) => {
  if (!rawDate) {
    return null;
  }

  const date = typeof rawDate === 'string' ? parseISO(rawDate) : rawDate;
  const Wrapper = tooltip ? Tooltip : Span;

  return (
    <Wrapper
      title={format(date, 'PPPp', {
        locale: enGB,
      })}
    >
      <span>
        {titlePrefix ? `${titlePrefix} ` : ''}
        {formatDistanceToNow(date, {
          addSuffix: true,
        })}
      </span>
    </Wrapper>
  );
};
